"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3189],{

/***/ 293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogoBlog = function SvgLogoBlog(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 137,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.796 5.036c.062.042.085.152.085.26 0 2.148.956 3.327 1.87 4.455l.15.185.173.218c.803 1.01 1.635 2.056 1.635 3.666 0 2.914-2.34 5.18-5.423 5.18-3.084 0-5.317-2.158-5.317-5.18 0-1.51.744-2.913 1.701-4.1.17-.216.298-.168.417-.058.176.164.362.438.468.653.32.54.71 1.024 1.242 1.347-.425-3.02 1.063-5.503 2.658-6.582.166-.112.28-.086.341-.044Zm-1.723 11.698c-.957 0-1.701-.755-1.701-1.619 0-.863.531-1.402 1.488-1.618.957-.216 2.02-.648 2.553-1.295.212.647.319 1.403.319 2.05-.107 1.295-1.277 2.482-2.659 2.482Zm-6.829-5.207h-4.28v7.29H.667v-9.87h7.578v2.58Zm19.859-2.58c.92 0 1.72.15 2.403.451.682.3 1.208.733 1.578 1.297.37.564.554 1.222.554 1.974s-.184 1.41-.554 1.974c-.37.564-.896.997-1.578 1.297-.683.301-1.484.452-2.403.452h-1.436v2.425H23.31v-9.87h4.792Zm-.214 4.878c.455 0 .797-.098 1.024-.296.228-.207.341-.493.341-.86 0-.366-.113-.648-.34-.846-.228-.207-.57-.31-1.025-.31h-1.222v2.312h1.222Zm15.034-4.878h-8.63v9.87h5.246c1.318 0 2.346-.287 3.085-.86.74-.574 1.11-1.363 1.11-2.37 0-.967-.328-1.705-.982-2.213-.644-.517-1.573-.775-2.786-.775H37.59v-1.142h5.332v-2.51Zm-2.844 7.332c-.18.14-.436.211-.767.211h-1.72v-1.579h1.72c.701 0 1.052.254 1.052.761 0 .264-.095.466-.285.607Zm5.945-7.332h3.299v5.132l3.427-5.132h3.156v9.87h-3.298v-5.119l-3.413 5.119h-3.17v-9.87Zm22.499 9.87v-9.87H60.12l-.128 3.85a18.74 18.74 0 0 1-.143 1.846c-.066.47-.194.846-.383 1.128-.18.282-.446.423-.797.423-.123 0-.246-.014-.37-.042l-.17 2.665c.502.122.976.183 1.422.183.881 0 1.56-.25 2.033-.747.474-.508.806-1.213.995-2.115.19-.903.304-2.059.342-3.469l.028-1.142h2.275v7.29h3.299Zm11.17-2.51v2.51h-8.275v-9.87h8.09v2.51h-4.791v1.156h4.208v2.397h-4.208v1.297h4.976Zm8.058-4.78h2.915v-2.58h-9.128v2.58h2.915v7.29h3.298v-7.29Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M105.948 12.372c.181 0 .32.089.417.267.098.179.146.405.146.68 0 .343-.048.61-.146.802a.774.774 0 0 1-.458.37 9.71 9.71 0 0 1-3.17.516c-.362 1.22-.932 2.154-1.71 2.8-.765.644-1.676.967-2.732.967-1.14 0-2.03-.33-2.67-.989-.64-.672-.959-1.694-.959-3.067 0-1.029.188-1.948.563-2.758.39-.824.91-1.462 1.564-1.915a3.648 3.648 0 0 1 2.169-.7c.417 0 .779.076 1.084.227a6.874 6.874 0 0 0-.667-.906c-.236-.288-.55-.645-.938-1.07-.5-.55-.89-.995-1.168-1.338a5.574 5.574 0 0 1-.71-1.132 3.133 3.133 0 0 1-.291-1.318c0-.631.18-1.132.542-1.502a3.392 3.392 0 0 1 1.335-.865c.528-.192 1.237-.391 2.127-.597.445-.11.897-.226 1.355-.35a7.457 7.457 0 0 0 1.147-.432.564.564 0 0 1 .251-.062c.194 0 .347.124.458.37.126.248.188.536.188.865 0 .233-.035.446-.104.638a.798.798 0 0 1-.292.391 4.001 4.001 0 0 1-1.189.515c-.417.096-.924.185-1.522.268-.654.096-1.133.205-1.44.329-.291.11-.437.33-.437.659 0 .22.104.473.313.761.222.275.563.659 1.022 1.153a27.948 27.948 0 0 1 1.543 1.791 7.99 7.99 0 0 1 1.084 1.853c.32.7.48 1.447.48 2.243 0 .234-.014.57-.042 1.01.765-.042 1.62-.186 2.565-.433a.938.938 0 0 1 .292-.041Zm-7.653 4.24c.43 0 .827-.233 1.188-.7.376-.48.675-1.098.897-1.852a3.02 3.02 0 0 1-.605-.989 3.58 3.58 0 0 1-.187-1.152c0-.124.014-.309.041-.556l-.396-.02c-.348 0-.674.143-.98.432-.292.288-.528.693-.71 1.214-.18.508-.27 1.084-.27 1.73 0 .603.076 1.07.23 1.4.166.329.43.493.792.493Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M117.015 14.1c.18 0 .319.083.417.248.111.164.167.39.167.68 0 .548-.132.973-.397 1.275-.458.536-.862.968-1.209 1.297a5.084 5.084 0 0 1-1.251.844c-.487.233-1.043.35-1.669.35-.82 0-1.404-.316-1.752-.947-.347-.645-.521-1.612-.521-2.902 0-.645.028-1.27.084-1.873h-.042c-.556 1.825-1.244 3.231-2.065 4.22-.806.987-1.731 1.482-2.773 1.482-.709 0-1.266-.254-1.669-.762s-.605-1.146-.605-1.915c0-.686.16-1.242.48-1.667.32-.425.772-.638 1.356-.638.264 0 .458.055.584.165.139.11.194.26.166.452-.111.66-.166 1.112-.166 1.36 0 .493.125.74.375.74.139 0 .292-.103.459-.309.181-.205.479-.706.897-1.502.319-.604.646-1.283.98-2.038.347-.755.632-1.427.855-2.018.222-.576.479-.967.771-1.173.292-.22.709-.33 1.252-.33.528 0 .917.104 1.167.31.251.205.376.542.376 1.008l-.042 1.523a57.765 57.765 0 0 0-.083 2.491c0 1.441.299 2.162.896 2.162.251 0 .494-.117.73-.35.251-.234.633-.659 1.147-1.277l.522-.617c.166-.192.354-.288.563-.288Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M126.792 12.372c.181 0 .32.089.417.267.097.179.146.405.146.68 0 .658-.202 1.05-.605 1.173-.834.288-1.752.453-2.753.494-.264 1.153-.785 2.079-1.564 2.779-.778.686-1.661 1.03-2.648 1.03-.834 0-1.55-.2-2.148-.598a3.832 3.832 0 0 1-1.335-1.585 5.018 5.018 0 0 1-.459-2.14c0-1.044.202-1.97.605-2.78.403-.823.959-1.461 1.668-1.914a4.197 4.197 0 0 1 2.357-.7c1.057 0 1.905.364 2.544 1.091.654.714 1.036 1.599 1.147 2.655.654-.04 1.432-.178 2.336-.411.111-.028.208-.041.292-.041Zm-6.84 4.24c.444 0 .827-.178 1.147-.535.333-.357.556-.872.667-1.544a2.93 2.93 0 0 1-1.001-1.132 3.394 3.394 0 0 1-.334-1.482c0-.22.021-.44.063-.659h-.104c-.557 0-1.022.268-1.398.803-.361.521-.542 1.262-.542 2.223 0 .755.146 1.331.438 1.73.306.397.66.596 1.064.596Z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M130.597 8.913c1.043 0 1.829.186 2.357.556.542.357.813.878.813 1.565 0 .59-.125 1.084-.375 1.482-.25.398-.549.713-.897.947-.347.233-.799.487-1.355.761-.598.302-1.036.563-1.314.783a1.07 1.07 0 0 0-.417.885c0 .302.111.514.333.638.223.123.612.185 1.168.185.82 0 1.634-.199 2.44-.597a6.847 6.847 0 0 0 2.169-1.729.696.696 0 0 1 .563-.288c.181 0 .32.082.417.247.111.164.167.39.167.68 0 .507-.132.932-.396 1.275a6.74 6.74 0 0 1-2.44 2.018c-.959.453-2.023.679-3.191.679-1.223 0-2.169-.206-2.836-.617-.667-.426-1.001-1.105-1.001-2.038 0-.59.125-1.091.375-1.503.264-.426.577-.769.939-1.03.375-.274.841-.555 1.397-.843.57-.302.987-.563 1.251-.783.264-.233.396-.507.396-.823a.458.458 0 0 0-.229-.412c-.153-.11-.375-.164-.667-.164-.264 0-.501.04-.709.123a4.166 4.166 0 0 0-.689.309c-.139.069-.285.137-.437.206a1.083 1.083 0 0 1-.397.082c-.264 0-.472-.082-.625-.247-.139-.178-.209-.405-.209-.68 0-.37.174-.685.522-.946.278-.206.688-.378 1.23-.515a6.684 6.684 0 0 1 1.647-.206Z",
    fill: "#F44336"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogoBlog);

/***/ }),

/***/ 3807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CookieAgreementModal; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1463);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _styled_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6196);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);
/* harmony import */ var _lib_api_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1377);
/* harmony import */ var _lib_api_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4154);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5944);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var _ref =  true ? {
  name: "1xnpl92",
  styles: "color:#F44336;:hover{color:#FF4A2E;}"
} : 0;

function CookieAgreementModal() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showPopUp = _useState[0],
      setShowPopUp = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      agreementPage = _useState2[0],
      setAgreementPage = _useState2[1];

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.u)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var userAgreed = Number(localStorage.getItem('user-agree-term')) === 1;

    if (!userAgreed) {
      if (sessionStorage.getItem('agreementPage')) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setAgreementPage(JSON.parse(sessionStorage.getItem('agreementPage')));
      } else {
        _lib_api_http__WEBPACK_IMPORTED_MODULE_3__/* .http.get */ .d.get(_lib_api_urls__WEBPACK_IMPORTED_MODULE_4__.V2.config, {}).then(function (config) {
          var _config$find;

          var showCookieWarningRequest = !!((_config$find = config.find(function (item) {
            return item.name === 'SHOW_COOKIE_WARNING';
          })) !== null && _config$find !== void 0 && _config$find.value);
          _lib_api_http__WEBPACK_IMPORTED_MODULE_3__/* .http.get */ .d.get(_lib_api_urls__WEBPACK_IMPORTED_MODULE_4__.V2.pages, {
            unique_content: 'agreement'
          }).then(function (pages) {
            if (pages.results.length > 0 && showCookieWarningRequest) {
              setAgreementPage(pages.results[0]);
              sessionStorage.setItem('agreementPage', JSON.stringify(pages.results[0]));
            }
          });
        });
      }
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (agreementPage) {
      setShowPopUp(true);
    }
  }, [agreementPage]);

  if (!showPopUp) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      fontFamily: 'Golos',
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: '9999',
      padding: 20,
      gap: 20,
      background: '#2c3135',
      width: 460,
      maxWidth: 'calc(100% - 40px)',
      borderRadius: 20
    }, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, {
      right: 8,
      maxWidth: 'calc(100% - 16px)'
    }),  true ? "" : 0,  true ? "" : 0),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)({
        color: theme.colors.white
      },  true ? "" : 0,  true ? "" : 0),
      children: ["\u041D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F cookies. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442 \u0432\u044B \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F", ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
        href: "/pages/".concat(agreementPage === null || agreementPage === void 0 ? void 0 : agreementPage.slug, "/"),
        css: _ref,
        children: "\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("button", {
      type: "button",
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)({
        width: 200,
        height: 50,
        background: '#FF4A2E',
        cursor: 'pointer',
        color: theme.colors.white,
        borderRadius: 16
      },  true ? "" : 0,  true ? "" : 0),
      onClick: function onClick() {
        localStorage.setItem('user-agree-term', '1');
        setShowPopUp(false);
      },
      children: "\u041E\u041A"
    })]
  });
}

/***/ }),

/***/ 1600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5944);



function Icon(_ref) {
  var iconId = _ref.iconId;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
    children: [iconId === 'angle-right' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      width: "10",
      height: "6",
      viewBox: "0 0 6 10",
      fill: "none",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L1.53033 0.46967ZM5 5L5.53033 5.53033C5.82322 5.23744 5.82322 4.76256 5.53033 4.46967L5 5ZM0.46967 8.46967C0.176777 8.76256 0.176777 9.23744 0.46967 9.53033C0.762563 9.82322 1.23744 9.82322 1.53033 9.53033L0.46967 8.46967ZM0.46967 1.53033L4.46967 5.53033L5.53033 4.46967L1.53033 0.46967L0.46967 1.53033ZM4.46967 4.46967L0.46967 8.46967L1.53033 9.53033L5.53033 5.53033L4.46967 4.46967Z"
      })
    }), iconId === 'angle-down' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      viewBox: "0 0 13 6",
      fill: "none",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M1.5 1L6.31481 5L11.5 1",
        strokeWidth: "1.5",
        strokeLinecap: "round"
      })
    }), iconId === 'star' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      fill: "none",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M7.42102 0.413024C7.60326 -0.137676 8.39674 -0.137674 8.57898 0.413026L10.0502 4.8588C10.1317 5.10508 10.3654 5.27183 10.6292 5.27183H15.3901C15.9798 5.27183 16.225 6.01279 15.7479 6.35314L11.8962 9.10078C11.6829 9.25299 11.5936 9.52279 11.6751 9.76907L13.1463 14.2148C13.3285 14.7655 12.6866 15.2235 12.2095 14.8831L8.35783 12.1355C8.14446 11.9833 7.85554 11.9833 7.64217 12.1355L3.79052 14.8831C3.31342 15.2235 2.67148 14.7655 2.85371 14.2148L4.32491 9.76907C4.40641 9.52279 4.31713 9.25299 4.10376 9.10078L0.252113 6.35314C-0.224993 6.01279 0.0202086 5.27183 0.609943 5.27183H5.37084C5.63458 5.27183 5.86832 5.10508 5.94982 4.8588L7.42102 0.413024Z"
      })
    }), iconId === 'star-outline' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      fill: "transparent",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M7.89571 0.570107C7.90572 0.539858 7.9193 0.526815 7.93129 0.518793C7.94661 0.508538 7.97053 0.5 8 0.5C8.02947 0.5 8.05339 0.508538 8.06871 0.518793C8.0807 0.526816 8.09429 0.539859 8.1043 0.570108L9.5755 5.01588C9.72627 5.4715 10.1547 5.77183 10.6292 5.77183H15.3901C15.4285 5.77183 15.4481 5.7825 15.4594 5.7911C15.4736 5.80184 15.4869 5.81927 15.4944 5.84193C15.5019 5.86461 15.501 5.88447 15.4969 5.89808C15.494 5.908 15.4867 5.92529 15.4575 5.9461L11.6059 8.69374C11.2166 8.97143 11.0491 9.46879 11.2004 9.92615L12.6716 14.3719C12.6816 14.402 12.6778 14.4181 12.6742 14.428C12.6692 14.4417 12.6571 14.4602 12.6348 14.4761C12.6125 14.492 12.5883 14.4994 12.568 14.5C12.5514 14.5004 12.5292 14.497 12.4999 14.4761L8.6482 11.7284C8.26109 11.4523 7.73891 11.4523 7.3518 11.7284L3.50015 14.4761C3.47081 14.497 3.44865 14.5004 3.432 14.5C3.41169 14.4994 3.3875 14.492 3.36524 14.4761C3.34294 14.4602 3.33081 14.4417 3.32579 14.428C3.3222 14.4181 3.31844 14.402 3.3284 14.3719L4.7996 9.92615C4.95095 9.46879 4.7834 8.97143 4.39413 8.69374L0.542484 5.94609C0.513314 5.92529 0.506021 5.908 0.503071 5.89808C0.499024 5.88447 0.498143 5.86461 0.505647 5.84193C0.513147 5.81927 0.526412 5.80184 0.540559 5.7911C0.551873 5.7825 0.571513 5.77183 0.609943 5.77183H5.37084C5.84527 5.77183 6.27373 5.4715 6.42451 5.01588L7.89571 0.570107Z",
        stroke: "#BFC1C3"
      })
    }), iconId === 'star-outline' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      fill: "transparent",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M7.89571 0.570107C7.90572 0.539858 7.9193 0.526815 7.93129 0.518793C7.94661 0.508538 7.97053 0.5 8 0.5C8.02947 0.5 8.05339 0.508538 8.06871 0.518793C8.0807 0.526816 8.09429 0.539859 8.1043 0.570108L9.5755 5.01588C9.72627 5.4715 10.1547 5.77183 10.6292 5.77183H15.3901C15.4285 5.77183 15.4481 5.7825 15.4594 5.7911C15.4736 5.80184 15.4869 5.81927 15.4944 5.84193C15.5019 5.86461 15.501 5.88447 15.4969 5.89808C15.494 5.908 15.4867 5.92529 15.4575 5.9461L11.6059 8.69374C11.2166 8.97143 11.0491 9.46879 11.2004 9.92615L12.6716 14.3719C12.6816 14.402 12.6778 14.4181 12.6742 14.428C12.6692 14.4417 12.6571 14.4602 12.6348 14.4761C12.6125 14.492 12.5883 14.4994 12.568 14.5C12.5514 14.5004 12.5292 14.497 12.4999 14.4761L8.6482 11.7284C8.26109 11.4523 7.73891 11.4523 7.3518 11.7284L3.50015 14.4761C3.47081 14.497 3.44865 14.5004 3.432 14.5C3.41169 14.4994 3.3875 14.492 3.36524 14.4761C3.34294 14.4602 3.33081 14.4417 3.32579 14.428C3.3222 14.4181 3.31844 14.402 3.3284 14.3719L4.7996 9.92615C4.95095 9.46879 4.7834 8.97143 4.39413 8.69374L0.542484 5.94609C0.513314 5.92529 0.506021 5.908 0.503071 5.89808C0.499024 5.88447 0.498143 5.86461 0.505647 5.84193C0.513147 5.81927 0.526412 5.80184 0.540559 5.7911C0.551873 5.7825 0.571513 5.77183 0.609943 5.77183H5.37084C5.84527 5.77183 6.27373 5.4715 6.42451 5.01588L7.89571 0.570107Z",
        stroke: "#BFC1C3"
      })
    }), iconId === 'whatsapp' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      width: "2500",
      height: "2500",
      viewBox: "0 0 1024 1024",
      fill: "none",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("defs", {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
          id: "a",
          d: "M1023.941 765.153c0 5.606-.171 17.766-.508 27.159-.824 22.982-2.646 52.639-5.401 66.151-4.141 20.306-10.392 39.472-18.542 55.425-9.643 18.871-21.943 35.775-36.559 50.364-14.584 14.56-31.472 26.812-50.315 36.416-16.036 8.172-35.322 14.426-55.744 18.549-13.378 2.701-42.812 4.488-65.648 5.3-9.402.336-21.564.505-27.15.505l-504.226-.081c-5.607 0-17.765-.172-27.158-.509-22.983-.824-52.639-2.646-66.152-5.4-20.306-4.142-39.473-10.392-55.425-18.542-18.872-9.644-35.775-21.944-50.364-36.56-14.56-14.584-26.812-31.471-36.415-50.314-8.174-16.037-14.428-35.323-18.551-55.744-2.7-13.378-4.487-42.812-5.3-65.649-.334-9.401-.503-21.563-.503-27.148l.08-504.228c0-5.607.171-17.766.508-27.159.825-22.983 2.646-52.639 5.401-66.151 4.141-20.306 10.391-39.473 18.542-55.426C34.154 93.24 46.455 76.336 61.07 61.747c14.584-14.559 31.472-26.812 50.315-36.416 16.037-8.172 35.324-14.426 55.745-18.549 13.377-2.701 42.812-4.488 65.648-5.3 9.402-.335 21.565-.504 27.149-.504l504.227.081c5.608 0 17.766.171 27.159.508 22.983.825 52.638 2.646 66.152 5.401 20.305 4.141 39.472 10.391 55.425 18.542 18.871 9.643 35.774 21.944 50.363 36.559 14.559 14.584 26.812 31.471 36.415 50.315 8.174 16.037 14.428 35.323 18.551 55.744 2.7 13.378 4.486 42.812 5.3 65.649.335 9.402.504 21.564.504 27.15l-.082 504.226z"
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("linearGradient", {
        id: "b",
        x1: "512.001",
        x2: "512.001",
        y1: ".978",
        y2: "1025.023",
        gradientUnits: "userSpaceOnUse",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0",
          stopColor: "#61fd7d"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "1",
          stopColor: "#2bb826"
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("use", {
        fill: "url(#b)",
        overflow: "visible",
        xlinkHref: "#a"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#FFF",
        d: "M783.302 243.246c-69.329-69.387-161.529-107.619-259.763-107.658-202.402 0-367.133 164.668-367.214 367.072-.026 64.699 16.883 127.854 49.017 183.522l-52.096 190.229 194.665-51.047c53.636 29.244 114.022 44.656 175.482 44.682h.151c202.382 0 367.128-164.688 367.21-367.094.039-98.087-38.121-190.319-107.452-259.706zM523.544 808.047h-.125c-54.767-.021-108.483-14.729-155.344-42.529l-11.146-6.612-115.517 30.293 30.834-112.592-7.259-11.544c-30.552-48.579-46.688-104.729-46.664-162.379.066-168.229 136.985-305.096 305.339-305.096 81.521.031 158.154 31.811 215.779 89.482s89.342 134.332 89.312 215.859c-.066 168.243-136.984 305.118-305.209 305.118zm167.415-228.515c-9.177-4.591-54.286-26.782-62.697-29.843-8.41-3.062-14.526-4.592-20.645 4.592-6.115 9.182-23.699 29.843-29.053 35.964-5.352 6.122-10.704 6.888-19.879 2.296-9.176-4.591-38.74-14.277-73.786-45.526-27.275-24.319-45.691-54.359-51.043-63.543-5.352-9.183-.569-14.146 4.024-18.72 4.127-4.109 9.175-10.713 13.763-16.069 4.587-5.355 6.117-9.183 9.175-15.304 3.059-6.122 1.529-11.479-.765-16.07-2.293-4.591-20.644-49.739-28.29-68.104-7.447-17.886-15.013-15.466-20.645-15.747-5.346-.266-11.469-.322-17.585-.322s-16.057 2.295-24.467 11.478-32.113 31.374-32.113 76.521c0 45.147 32.877 88.764 37.465 94.885 4.588 6.122 64.699 98.771 156.741 138.502 21.892 9.45 38.982 15.094 52.308 19.322 21.98 6.979 41.982 5.995 57.793 3.634 17.628-2.633 54.284-22.189 61.932-43.615 7.646-21.427 7.646-39.791 5.352-43.617-2.294-3.826-8.41-6.122-17.585-10.714z"
      })]
    }), iconId === 'email' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "#4F9AE5"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M6.28441 6.66675H17.713C18.6654 6.66675 18.6654 6.66675 18.6654 7.60791V16.6403C18.6654 17.365 18.4463 17.3332 17.7129 17.3332H6.28441C5.33203 17.3332 5.33203 17.3445 5.33203 16.5289V7.60791C5.33203 6.66675 5.33203 6.66675 6.28441 6.66675Z",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M18.6653 7.29395L11.9987 11.9056L5.33203 7.29395",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), iconId === 'vk' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "#5B7FA6"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M19.342 8.35286C19.4558 7.98449 19.342 7.71436 18.804 7.71436H17.0217C16.5682 7.71436 16.3609 7.94805 16.2471 8.20472C16.2471 8.20472 15.341 10.3587 14.0569 11.7553C13.6424 12.1617 13.453 12.29 13.2271 12.29C13.1141 12.29 12.9499 12.1617 12.9499 11.7933V8.35286C12.9499 7.91082 12.8191 7.71436 12.4412 7.71436H9.64052C9.35769 7.71436 9.18702 7.91874 9.18702 8.11362C9.18702 8.53189 9.82907 8.62854 9.8949 9.80731V12.3645C9.8949 12.9245 9.79169 13.0267 9.56412 13.0267C8.96027 13.0267 7.49087 10.8649 6.61881 8.39009C6.44895 7.90923 6.27747 7.71515 5.82235 7.71515H4.04086C3.53128 7.71515 3.42969 7.94884 3.42969 8.20551C3.42969 8.66656 4.03354 10.9481 6.24252 13.9655C7.71518 16.0259 9.78844 17.1429 11.6772 17.1429C12.8093 17.1429 12.9491 16.895 12.9491 16.4672V14.9098C12.9491 14.4139 13.0572 14.314 13.4156 14.314C13.6789 14.314 14.1324 14.444 15.1898 15.4366C16.3975 16.6137 16.5974 17.1421 17.2761 17.1421H19.0575C19.5663 17.1421 19.8207 16.8942 19.6744 16.4046C19.5143 15.9174 18.9373 15.2084 18.1717 14.3695C17.7556 13.891 17.1338 13.3761 16.9445 13.1186C16.6803 12.7867 16.7567 12.6402 16.9445 12.3455C16.9453 12.3463 19.1161 9.36606 19.342 8.35286Z",
        fill: "white"
      })]
    }), iconId === 'telegram' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "#40B3E0"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M19.3333 5.80252L16.9081 18.0297C16.9081 18.0297 16.569 18.8776 15.6363 18.4706L10.04 14.1801L8.00507 13.1966L4.57949 12.0433C4.57949 12.0433 4.05378 11.8568 4.00287 11.4498C3.95195 11.0428 4.59646 10.8224 4.59646 10.8224L18.2139 5.48047C18.2139 5.48047 19.3332 4.98871 19.3332 5.80273",
        fill: "white"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M9.60882 17.8921C9.60882 17.8921 9.44546 17.8768 9.2418 17.2323C9.03845 16.5879 8.00391 13.1962 8.00391 13.1962L16.2287 7.97311C16.2287 7.97311 16.7036 7.6848 16.6867 7.97311C16.6867 7.97311 16.7714 8.02402 16.5169 8.26142C16.2627 8.49892 10.0559 14.0781 10.0559 14.0781",
        fill: "#D2E5F1"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M12.1852 15.8248L9.97173 17.843C9.97173 17.843 9.79861 17.9743 9.60938 17.892L10.0333 14.1433",
        fill: "#B5CFE4"
      })]
    }), iconId === 'instagram' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      viewBox: "6 6 36 36",
      width: "48px",
      height: "48px",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("radialGradient", {
        id: "yOrnnhliCrdS2gy~4tD8ma",
        cx: "19.38",
        cy: "42.035",
        r: "44.899",
        gradientUnits: "userSpaceOnUse",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0",
          stopColor: "#fd5"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.328",
          stopColor: "#ff543f"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.348",
          stopColor: "#fc5245"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.504",
          stopColor: "#e64771"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.643",
          stopColor: "#d53e91"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.761",
          stopColor: "#cc39a4"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.841",
          stopColor: "#c837ab"
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "url(#yOrnnhliCrdS2gy~4tD8ma)",
        d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("radialGradient", {
        id: "yOrnnhliCrdS2gy~4tD8mb",
        cx: "11.786",
        cy: "5.54",
        r: "29.813",
        gradientTransform: "matrix(1 0 0 .6663 0 1.849)",
        gradientUnits: "userSpaceOnUse",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0",
          stopColor: "#4168c9"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("stop", {
          offset: "0.999",
          stopColor: "#4168c9",
          stopOpacity: "0"
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "url(#yOrnnhliCrdS2gy~4tD8mb)",
        d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#fff",
        d: "M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5 s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
        cx: "31.5",
        cy: "16.5",
        r: "1.5",
        fill: "#fff"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#fff",
        d: "M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12 C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
      })]
    }), iconId === 'youtube' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      viewBox: "6 6 36 36",
      css: "width: 22px;height: 22px;",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5 V37z",
        fill: "#f44336"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M36.499,25.498c-0.276-0.983-1.089-1.758-2.122-2.021C32.506,23,24,23,24,23s-8.506,0-10.377,0.478 c-1.032,0.263-1.846,1.037-2.122,2.021C11,27.281,11,31,11,31s0,3.719,0.501,5.502c0.276,0.983,1.089,1.758,2.122,2.021 C15.494,39,24,39,24,39s8.505,0,10.377-0.478c1.032-0.263,1.846-1.037,2.122-2.021C37,34.719,37,31,37,31S37,27.281,36.499,25.498z",
        fill: "#fff"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M16.333 37L14.667 37 14.667 26.655 13 26.655 13 25 18 25 18 26.655 16.333 26.655zM23 37h-1.5l-.167-1.132C20.675 36.579 19.892 37 19.283 37c-.533 0-.908-.231-1.092-.653C18.083 36.083 18 35.687 18 35.092V27.5h1.667v7.757c.042.24.217.33.433.33.333 0 .867-.363 1.233-.843V27.5H23V37zM35 32.663v-2.701c0-.777-.192-1.338-.533-1.702-.458-.496-1.117-.76-1.942-.76-.842 0-1.492.264-1.967.76C30.2 28.623 30 29.218 30 29.995v4.593c0 .768.225 1.313.575 1.669C31.05 36.752 31.7 37 32.567 37c.858 0 1.533-.256 1.983-.785.2-.231.333-.496.392-.785C34.95 35.298 35 34.943 35 34.522h-1.667v.661c0 .38-.375.694-.833.694s-.833-.314-.833-.694v-2.52H35zM31.667 29.392c0-.388.375-.694.833-.694s.833.306.833.694v2.123h-1.667V29.392zM28.783 28.492c-.208-.646-.717-1.001-1.35-1.01-.808-.008-1.142.414-1.767 1.142V25H24v12h1.5l.167-1.034C26.192 36.611 26.875 37 27.433 37c.633 0 1.175-.331 1.383-.977.1-.348.175-.67.183-1.399V30.28C29 29.461 28.892 28.84 28.783 28.492zM27.333 34.41c0 .869-.2 1.167-.65 1.167-.258 0-.75-.174-1.017-.439v-5.686c.267-.265.758-.521 1.017-.521.45 0 .65.273.65 1.142V34.41z",
        fill: "#f44336"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M15 9l1.835.001 1.187 5.712.115 0 1.128-5.711 1.856-.001L19 16.893V21h-1.823l-.003-3.885L15 9zM21.139 14.082c0-.672.219-1.209.657-1.606.437-.399 1.024-.6 1.764-.601.675 0 1.225.209 1.655.63.429.418.645.96.645 1.622l.003 4.485c0 .742-.209 1.326-.63 1.752C24.812 20.788 24.234 21 23.493 21c-.714 0-1.281-.221-1.712-.656-.428-.435-.64-1.023-.641-1.76l-.003-4.503L21.139 14.082 21.139 14.082zM22.815 18.746c0 .236.057.423.178.553.115.128.279.193.495.193.221 0 .394-.066.524-.201.129-.129.196-.314.196-.547l-.003-4.731c0-.188-.069-.342-.201-.459-.131-.116-.305-.175-.519-.175-.199 0-.361.06-.486.176-.124.117-.186.271-.186.459L22.815 18.746zM32 12v9h-1.425l-.227-1.1c-.305.358-.622.63-.953.815C29.067 20.901 28.747 21 28.437 21c-.384 0-.671-.132-.866-.394-.195-.259-.291-.65-.291-1.174L27.276 12h1.653l.004 6.825c0 .204.036.355.106.449.066.09.183.14.335.14.124 0 .278-.062.46-.186.188-.122.358-.281.512-.471L30.344 12 32 12z",
        fill: "#fff"
      })]
    }), iconId === 'odnoklassniki' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      viewBox: "6 6 36 36",
      width: "48px",
      height: "48px",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#FF9800",
        d: "M42,37c0,2.8-2.2,5-5,5H11c-2.8,0-5-2.2-5-5V11c0-2.8,2.2-5,5-5h26c2.8,0,5,2.2,5,5V37z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#FFF",
        d: "M26.9,30.4c1.5-0.3,2.9-0.9,4.1-1.7c1-0.6,1.3-1.9,0.7-2.9c-0.6-1-1.9-1.3-2.9-0.7c-2.9,1.8-6.7,1.8-9.6,0c-1-0.6-2.3-0.3-2.9,0.7c-0.6,1-0.3,2.3,0.7,2.9c1.3,0.8,2.7,1.4,4.1,1.7l-4,4c-0.8,0.8-0.8,2.1,0,3c0.4,0.4,0.9,0.6,1.5,0.6c0.5,0,1.1-0.2,1.5-0.6l3.9-3.9l3.9,3.9c0.8,0.8,2.1,0.8,3,0c0.8-0.8,0.8-2.1,0-3C30.9,34.4,26.9,30.4,26.9,30.4z M24,10c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C31,13.1,27.9,10,24,10z M24,20c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3C27,18.7,25.7,20,24,20z"
      })]
    }), iconId === 'facebook' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      viewBox: "6 6 36 36",
      width: "48px",
      height: "48px",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#3F51B5",
        d: "M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        fill: "#FFF",
        d: "M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
      })]
    }), iconId === 'phone' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "#02A64F"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M15.6483 15.6678L15.6493 15.6668C17.6297 13.6748 19.0029 11.139 19.6032 8.36629L19.6035 8.36493L19.6035 8.36492C19.6779 8.00169 19.6597 7.625 19.5505 7.271C19.4414 6.91726 19.2451 6.59786 18.9801 6.34361L17.2383 4.62914L17.2375 4.62837L17.2375 4.62837C17.1359 4.53007 17.0149 4.45463 16.8825 4.40713C16.75 4.35964 16.6092 4.34122 16.4692 4.35313L16.4665 4.35335L16.4665 4.35338C16.3214 4.36887 16.1814 4.41667 16.0566 4.49329C15.9317 4.56989 15.825 4.67339 15.7439 4.79633L15.7439 4.79626L15.8482 4.86523L15.7438 4.79635L13.5659 8.08823L13.5648 8.08985L13.5648 8.08986C13.4689 8.23989 13.4228 8.41712 13.4329 8.59554C13.443 8.77395 13.5088 8.94468 13.6212 9.08255L13.6213 9.08273L14.6658 10.3594C14.2387 11.3027 13.6423 12.1559 12.9076 12.8744L12.9057 12.8762L12.9057 12.8762C12.1754 13.6212 11.3154 14.2195 10.3704 14.6405L9.07497 13.5884L9.07474 13.5882C8.94109 13.4802 8.77812 13.4161 8.60744 13.4048C8.43674 13.3935 8.26693 13.4357 8.12063 13.5254L8.11698 13.5276L8.11702 13.5277L4.83005 15.7003C4.70178 15.7791 4.59271 15.8862 4.5108 16.0135C4.42846 16.1416 4.37563 16.2868 4.35609 16.4383C4.33655 16.5899 4.35079 16.744 4.3978 16.8892C4.4448 17.0344 4.5234 17.1671 4.6279 17.2772L4.62963 17.2791L4.62965 17.279L6.32826 18.9983C6.53278 19.2064 6.77569 19.3713 7.04308 19.4833C7.31048 19.5952 7.59699 19.6521 7.8861 19.6504M15.6483 15.6678L7.88539 19.5254M15.6483 15.6678C13.6254 17.6546 11.0949 19.0172 8.34763 19.5986M15.6483 15.6678L8.32099 19.4764M7.8861 19.6504L7.88539 19.5254M7.8861 19.6504C7.88598 19.6504 7.88586 19.6504 7.88574 19.6504L7.88539 19.5254M7.8861 19.6504C8.04132 19.65 8.19604 19.6326 8.34763 19.5986M7.88539 19.5254C8.03188 19.525 8.17791 19.5086 8.32099 19.4764M8.34763 19.5986C8.34737 19.5986 8.34711 19.5987 8.34686 19.5987L8.32099 19.4764M8.34763 19.5986C8.34788 19.5985 8.34814 19.5984 8.3484 19.5984L8.32099 19.4764M15.703 9.89272C15.7676 9.96327 15.8133 10.0492 15.8364 10.1423C15.8597 10.2368 15.8589 10.3358 15.834 10.4299L15.8346 10.4301L15.83 10.4422C15.3618 11.6774 14.6269 12.789 13.68 13.6938C12.7644 14.6444 11.6546 15.3767 10.4298 15.8381L10.4299 15.8383L10.4239 15.8402C10.3363 15.8683 10.2433 15.8741 10.153 15.857C10.0626 15.8399 9.97797 15.8006 9.90634 15.7426L9.90604 15.7424L8.52235 14.6154L5.55042 16.579L7.14231 18.1903L7.14244 18.1904C7.26859 18.3185 7.42361 18.4123 7.59348 18.4637C7.76333 18.5151 7.94293 18.5226 8.11626 18.4855L8.11655 18.4855C10.6559 17.949 12.9959 16.69 14.867 14.853C16.6871 13.0138 17.9478 10.6745 18.4963 8.11774C18.5329 7.94662 18.5252 7.7687 18.4741 7.60157C18.4231 7.43446 18.3304 7.28413 18.2056 7.16522L18.2056 7.16523L18.2042 7.16381L16.5696 5.55489L14.5877 8.52828L15.703 9.89272Z",
        fill: "white",
        stroke: "white",
        strokeWidth: "0.25"
      })]
    })]
  });
}

/***/ }),

/***/ 4647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(1463);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(120);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/styled/Link.tsx
var Link = __webpack_require__(6196);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(7135);
;// CONCATENATED MODULE: ./public/img/mastercard.png
/* harmony default export */ var mastercard = ({"src":"/_next/static/media/mastercard.2771fec6.png","height":16,"width":38,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAVklEQVR42mN4wyDFyAAELxlkZn2QEX34c4LIg28LZRYyoINXDDInP6sK/f/dK/QfqODy30Q2FgYQeMMgDTZhIQOf6SYGoYxD1cJJO0oFjRiA4P9iGUYAjCEb8i2+7r0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/img/mir.png
/* harmony default export */ var mir = ({"src":"/_next/static/media/mir.a93d2e07.png","height":24,"width":38,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAiElEQVR4nGP8////ewYGBgEg/g/EjEAMAjD2B8bV17b+1xPTZLj25jaDJK8Ew9+/3xi+/BVhePxKnEGI6StQ1Wqbfw7c2owsDEwM0uzCDKe/3WMIEXFg2PacjcGIWeg/47a7B/6zMbEyMDMxM3z5+ZVBmlec4dHnZwwqApIM2qI6DPjd8J/hPQAuSC/+d3D9vgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/img/visa.png
/* harmony default export */ var visa = ({"src":"/_next/static/media/visa.943fffbd.png","height":24,"width":53,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAhElEQVR4nB3KwQ7BMACA4b8zXUX2CA7s7hUkEjcJryhewBJ38QLOjm67rGgbhk5L9p0/UVW1FYJcZhnWNUSRkPYSpJQMVOrE7W7jrjzypc/Lg7Yty8WU8nBhPS8Q8W+z3WPsm3ExovlETuca/UhYzSZdsPpq8hAi3geMe5IpRT5UtCG6H1rQPVZUZCEXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/img/lock.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.152 6.696c.499 0 .932.186 1.298.558.367.372.55.811.55 1.317v9.554c0 .506-.183.945-.55 1.317-.366.372-.799.558-1.297.558H1.892c-.528 0-.976-.186-1.342-.558A1.814 1.814 0 0 1 0 18.125V8.571c0-.506.183-.945.55-1.317a1.812 1.812 0 0 1 1.341-.558h.924v-1.92c0-1.309.462-2.432 1.386-3.37C5.125.47 6.23 0 7.522 0c1.29 0 2.39.469 3.3 1.406.908.938 1.363 2.061 1.363 3.37v1.92h.967ZM7.5 15.268c.513 0 .953-.186 1.32-.558.366-.372.55-.826.55-1.362 0-.536-.184-.99-.55-1.361a1.787 1.787 0 0 0-1.32-.558c-.513 0-.953.186-1.32.558-.366.372-.55.825-.55 1.361s.184.99.55 1.362c.367.372.807.558 1.32.558Zm2.925-8.572v-1.92c0-.803-.286-1.495-.858-2.075A2.797 2.797 0 0 0 7.5 1.83c-.806 0-1.488.29-2.045.87a2.894 2.894 0 0 0-.836 2.076v1.92h5.806Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var lock = (SvgLock);
;// CONCATENATED MODULE: ./public/img/logo-footer.svg
var logo_footer_path;
function logo_footer_extends() { logo_footer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_footer_extends.apply(this, arguments); }

var SvgLogoFooter = function SvgLogoFooter(props) {
  return /*#__PURE__*/react.createElement("svg", logo_footer_extends({
    viewBox: "0 0 90 14"
  }, props), logo_footer_path || (logo_footer_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.13.036c.062.042.085.152.085.26 0 2.148.956 3.327 1.87 4.455l.15.185.173.218c.803 1.01 1.635 2.056 1.635 3.667 0 2.913-2.34 5.179-5.423 5.179-3.084 0-5.317-2.158-5.317-5.18 0-1.51.744-2.913 1.701-4.1.17-.216.298-.168.417-.058.176.164.362.438.468.654.32.54.71 1.023 1.242 1.346-.425-3.02 1.063-5.503 2.658-6.582.166-.112.28-.086.341-.044Zm-1.723 11.698c-.957 0-1.701-.755-1.701-1.619 0-.863.531-1.402 1.488-1.618.957-.216 2.02-.648 2.553-1.295.212.647.319 1.403.319 2.05-.107 1.295-1.277 2.482-2.659 2.482ZM7.578 6.527h-4.28v7.29H0v-9.87h7.578v2.58Zm19.859-2.58c.92 0 1.72.15 2.402.451.683.3 1.21.733 1.579 1.297.37.564.554 1.222.554 1.974s-.184 1.41-.554 1.974c-.37.564-.896.997-1.578 1.297-.683.301-1.484.452-2.403.452H26v2.425h-3.356v-9.87h4.792Zm-.214 4.878c.455 0 .797-.098 1.024-.296.228-.206.341-.493.341-.86 0-.366-.113-.648-.34-.846-.228-.207-.57-.31-1.025-.31h-1.222v2.312h1.222Zm15.034-4.878h-8.63v9.87h5.246c1.318 0 2.346-.287 3.086-.86.739-.574 1.108-1.363 1.108-2.37 0-.967-.327-1.705-.98-2.213-.645-.517-1.574-.775-2.787-.775h-2.375V6.457h5.332v-2.51Zm-2.844 7.332c-.18.14-.436.211-.767.211h-1.72V9.911h1.72c.701 0 1.052.254 1.052.761 0 .264-.095.466-.285.607Zm5.945-7.332h3.299v5.132l3.427-5.132h3.156v9.87h-3.299V8.699l-3.412 5.118h-3.17v-9.87Zm22.499 9.87v-9.87h-8.403l-.128 3.85a18.77 18.77 0 0 1-.143 1.846c-.066.47-.194.846-.383 1.128-.18.282-.446.423-.797.423-.123 0-.246-.014-.37-.042l-.17 2.665c.502.122.976.183 1.422.183.881 0 1.56-.25 2.033-.747.474-.508.806-1.213.995-2.115.19-.903.304-2.059.342-3.469l.028-1.142h2.275v7.29h3.299Zm11.17-2.51v2.51h-8.275v-9.87h8.09v2.51h-4.791v1.156h4.208v2.397h-4.208v1.297h4.976Zm8.058-4.78H90v-2.58h-9.128v2.58h2.915v7.29h3.298v-7.29Z"
  })));
};
/* harmony default export */ var logo_footer = (SvgLogoFooter);
// EXTERNAL MODULE: ./public/img/logo-blog.svg
var logo_blog = __webpack_require__(293);
;// CONCATENATED MODULE: ./public/img/logo-sk-uchastnik.svg
var _defs, logo_sk_uchastnik_path, _path2;
function logo_sk_uchastnik_extends() { logo_sk_uchastnik_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_sk_uchastnik_extends.apply(this, arguments); }

var SvgLogoSkUchastnik = function SvgLogoSkUchastnik(props) {
  return /*#__PURE__*/react.createElement("svg", logo_sk_uchastnik_extends({
    id: "logo-sk-uchastnik_svg___\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.32 49.24"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".logo-sk-uchastnik_svg__cls-1{fill:#fff;stroke-width:0}"))), logo_sk_uchastnik_path || (logo_sk_uchastnik_path = /*#__PURE__*/react.createElement("path", {
    className: "logo-sk-uchastnik_svg__cls-1",
    d: "M47.62 1.62v35.31c0 5.9-4.8 10.69-10.69 10.69H12.31c-5.9 0-10.69-4.8-10.69-10.69V12.31c0-5.9 4.79-10.69 10.69-10.69h35.31M49.24 0H12.31C5.51 0 0 5.51 0 12.31v24.62c0 6.8 5.51 12.31 12.31 12.31h24.62c6.8 0 12.31-5.51 12.31-12.31V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "logo-sk-uchastnik_svg__cls-1",
    d: "M40.69 18.46h-5.91l-5.62 6.16V12.31H24.6v2.98a12.1 12.1 0 0 0-.48-.57c-1.66-1.76-4.05-2.65-7.11-2.65-3.53 0-5.54 1.58-6.61 2.91-1.32 1.65-1.91 3.9-1.5 5.73 1.06 4.74 5.46 5.5 8.69 5.92 2.55.33 4.99.8 4.93 3.07-.07 2.36-2.73 2.94-4.48 2.94-4.55 0-4.7-3.36-4.7-3.36H8.45c.07 1.26.45 3.29 2.01 5.03 1.7 1.91 4.26 2.87 7.59 2.87 2.56 0 4.89-.83 6.55-2.31v2.03h4.56v-5.81l1.61-1.77 4.61 7.58h5.31l-6.71-11.09 6.71-7.35Zm-16.1 5.56c-3.27-2.69-10.37-1-11.13-4.35-.4-1.76 1.35-3.32 3.63-3.32 2.05 0 4.1.46 4.88 3.31h2.62v4.36ZM60.85 33.82c.31.1.66.15 1.07.15.51 0 .92-.15 1.23-.46.31-.31.51-.72.61-1.17L57.27 18.6h4.32l4.16 9.86 3.65-9.86h4.11l-5.85 13.54c-.77 1.79-1.56 3.12-2.43 3.96-.87.87-1.81 1.3-2.86 1.3-.36 0-.64 0-.87-.05a3.98 3.98 0 0 1-.64-.13l-.49-.15c-.13-.05-.26-.1-.38-.13v-3.47c.23.15.51.28.84.36ZM80.55 31.78c-.26.08-.54.13-.84.2-.31.05-.64.1-.97.13-.33.05-.66.05-.97.05-.79 0-1.46-.08-2.07-.2-.59-.15-1.1-.36-1.51-.66s-.72-.72-.92-1.23c-.2-.49-.31-1.1-.31-1.81v-4.9h3.52v4.21c0 .38.05.72.15.94.08.26.23.46.43.61.2.15.43.26.74.31s.66.08 1.07.08c.61 0 1.07-.05 1.43-.15.36-.13.64-.26.84-.38v-5.62h3.52v13.59h-3.52v-5.36c-.15.05-.36.13-.61.2ZM98.33 35.25c.03.26.1.49.18.61.08.18.15.28.26.36.1.08.18.13.31.15v.56h-3.91l-.2-.64c-.1-.26-.13-.56-.13-.95l-.79.79c-.28.23-.56.43-.89.61-.33.18-.69.33-1.12.43-.43.1-.95.15-1.53.15s-1.17-.08-1.69-.26c-.51-.18-.94-.46-1.33-.79-.36-.36-.66-.79-.87-1.33-.2-.51-.31-1.12-.31-1.81 0-.56.08-1.07.26-1.56s.43-.89.74-1.25c.33-.36.72-.66 1.17-.89.46-.26.97-.41 1.56-.49l3.45-.51c.13-.03.26-.03.41-.08a.94.94 0 0 0 .41-.18.92.92 0 0 0 .31-.31c.08-.15.13-.33.13-.56s-.05-.43-.1-.61c-.08-.2-.2-.36-.36-.49-.18-.15-.38-.26-.66-.33-.28-.08-.64-.1-1.05-.1-.49 0-.84.05-1.12.13-.31.1-.54.26-.69.41-.18.18-.31.38-.38.59l-.15.74h-3.52c0-.15.03-.38.08-.69.05-.28.15-.61.31-.97.13-.33.36-.69.61-1.05.26-.36.59-.69 1.05-1 .41-.28.95-.54 1.56-.72.61-.18 1.33-.28 2.2-.31 1.2 0 2.2.13 2.96.36.74.26 1.33.59 1.76.97.41.41.69.84.84 1.33.13.49.2.97.2 1.46v7.2c0 .41.03.74.08 1Zm-4.24-4.65c-.23.1-.51.2-.87.26l-.94.18c-.41.08-.77.15-1.07.26-.31.1-.56.23-.77.38-.2.18-.36.38-.46.61-.1.23-.15.51-.15.87 0 .28.05.54.13.74.1.23.23.38.41.54.15.13.33.26.54.31.23.08.46.1.72.1.13 0 .31-.03.51-.05.2-.03.41-.08.66-.15.23-.1.46-.2.69-.36.23-.13.43-.33.61-.56.2-.23.36-.51.46-.87.1-.33.18-.72.18-1.17v-1.38c-.2.13-.43.23-.64.31ZM108.19 27.21c-.1-.28-.26-.51-.43-.69-.2-.2-.43-.33-.69-.43-.28-.08-.61-.13-1-.13-.59 0-1.05.13-1.4.41-.36.28-.64.61-.82 1.02-.2.43-.31.89-.38 1.38-.05.49-.1.94-.1 1.38s.03.92.08 1.4c.05.51.15.94.36 1.35.18.41.43.77.82 1.02.36.28.84.41 1.46.41.41 0 .77-.08 1.07-.26.28-.15.54-.36.74-.59.2-.26.36-.51.46-.79.08-.26.13-.51.13-.74h3.68c0 .23-.03.51-.1.87-.1.38-.23.74-.41 1.15-.18.38-.43.79-.72 1.2-.33.41-.69.77-1.15 1.07-.46.33-.97.59-1.58.79-.61.2-1.33.31-2.12.31-1.02 0-1.94-.15-2.73-.46-.79-.33-1.46-.79-1.99-1.4-.54-.61-.95-1.35-1.23-2.27-.28-.89-.43-1.92-.43-3.06s.15-2.2.46-3.09c.31-.87.74-1.63 1.3-2.25.56-.61 1.23-1.07 2.02-1.38.77-.33 1.66-.49 2.61-.49.41 0 .84.05 1.3.1.43.05.87.18 1.3.33.43.18.84.38 1.25.64.38.26.74.59 1.07.97.31.38.56.84.77 1.35.2.51.33 1.12.38 1.81h-3.68c-.08-.36-.15-.69-.28-.94ZM124.45 23.35v2.86h-4.11v10.73h-3.52V26.21h-4.11v-2.86h11.75ZM134.25 28.26v-4.9h3.52v13.59h-3.52v-5.82h-5.18v5.82h-3.52V23.36h3.52v4.9h5.18ZM143.71 31.73l4.96-8.38h3.7v13.59h-3.52v-8.2h-.05l-4.8 8.2h-3.86V23.35h3.52v8.38h.05ZM163.39 23.35h4.7l-5.62 5.64 5.85 7.94h-4.6l-3.98-5.75-1.43 1.46v4.29h-3.52V23.34h3.52v5.16l5.08-5.16Z"
  })));
};
/* harmony default export */ var logo_sk_uchastnik = (SvgLogoSkUchastnik);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(5319);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
;// CONCATENATED MODULE: ./components/layout/Footer/styled.tsx



var FooterTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cihvzr1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return (0,defineProperty/* default */.Z)({
    fontSize: '16px',
    fontWeight: 700,
    letterSpacing: '1px',
    color: theme.colors.red,
    textTransform: 'uppercase',
    marginBottom: '1em'
  }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
    display: 'inline-block'
  });
},  true ? "" : 0);
var FooterList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1cihvzr0"
} : 0)(function (_ref3) {
  var _li, _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    padding: 0,
    margin: 0
  }, (0,defineProperty/* default */.Z)(_ref4, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
    display: 'inline-block'
  }), (0,defineProperty/* default */.Z)(_ref4, "listStyle", 'none'), (0,defineProperty/* default */.Z)(_ref4, '&>li', (_li = {
    marginBottom: '0.45em'
  }, (0,defineProperty/* default */.Z)(_li, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
    textAlign: 'center'
  }), (0,defineProperty/* default */.Z)(_li, '&>div', {
    marginBottom: '0.45em'
  }), (0,defineProperty/* default */.Z)(_li, '&>a', {
    textDecoration: 'none',
    color: theme.colors.white,
    '&:hover': {
      textDecoration: 'underline'
    }
  }), _li)), _ref4;
},  true ? "" : 0);
// EXTERNAL MODULE: ./components/icon/icon.tsx
var icon = __webpack_require__(1600);
// EXTERNAL MODULE: ./lib/api/apiUrl.ts
var apiUrl = __webpack_require__(7050);
// EXTERNAL MODULE: ./models/page.ts
var page = __webpack_require__(3393);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/layout/Footer/Footer.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var SITE_SECTIONS = {
  company: 'company',
  clients: 'for_clients',
  help: 'help'
};
var CONCACT_TYPES = {
  email: 'email',
  telephone: 'телефон',
  openingHours: 'график',
  name: 'название',
  address: 'адрес'
};

var _ref2 =  true ? {
  name: "1k0t4vh",
  styles: "width:90%"
} : 0;

var _ref3 =  true ? {
  name: "1eo2bs0",
  styles: "width:38px"
} : 0;

var _ref4 =  true ? {
  name: "nrjqhq",
  styles: "margin:0;padding:0;list-style:none;li{position:relative;margin:12px 0;svg{position:absolute;top:0;}}"
} : 0;

var _ref5 =  true ? {
  name: "oxutyg",
  styles: "left:-30px"
} : 0;

var _ref6 =  true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0;

var _ref7 =  true ? {
  name: "gtxiwt",
  styles: "width:120px;height:40px;margin-top:12px"
} : 0;

var _ref8 =  true ? {
  name: "ot4ncn",
  styles: "font-size:10px"
} : 0;

var _ref9 =  true ? {
  name: "qqku7y",
  styles: "background-color:rgba(255, 255, 255, 0.1);flex:0 0 auto;width:2px;margin:0 90px;padding:0;order:1"
} : 0;

var _ref10 =  true ? {
  name: "1oq5522",
  styles: "min-width:184px"
} : 0;

var _ref11 =  true ? {
  name: "mgb3ws",
  styles: "svg{width:22px;height:22px;}display:flex;flex-wrap:wrap;a:not(:last-child){margin-right:12px;margin-bottom:6px;}"
} : 0;

var _ref12 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _ref13 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _ref14 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _ref15 =  true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0;

var _ref16 =  true ? {
  name: "mgb3ws",
  styles: "svg{width:22px;height:22px;}display:flex;flex-wrap:wrap;a:not(:last-child){margin-right:12px;margin-bottom:6px;}"
} : 0;

var _ref17 =  true ? {
  name: "r6qx4u",
  styles: "display:none;margin-bottom:12px"
} : 0;

var _ref18 =  true ? {
  name: "mgb3ws",
  styles: "svg{width:22px;height:22px;}display:flex;flex-wrap:wrap;a:not(:last-child){margin-right:12px;margin-bottom:6px;}"
} : 0;

var _ref19 =  true ? {
  name: "rvlm2n",
  styles: "font-family:Golos;display:none;margin-bottom:12px"
} : 0;

var _ref20 =  true ? {
  name: "mgb3ws",
  styles: "svg{width:22px;height:22px;}display:flex;flex-wrap:wrap;a:not(:last-child){margin-right:12px;margin-bottom:6px;}"
} : 0;

function Footer(_ref) {
  var _css2, _css3, _css4, _css5, _css8, _css9, _css11, _css14;

  var pageList = _ref.pageList,
      socials = _ref.socials,
      socialsLinks = _ref.socialsLinks,
      contactList = _ref.contactList,
      currentCity = _ref.currentCity,
      className = _ref.className;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var currentYear = luxon/* DateTime.now */.ou.now().year;

  var _useState = (0,react.useState)(false),
      isMobileMode = _useState[0],
      setIsMobileMode = _useState[1];

  (0,react.useEffect)(function () {
    setIsMobileMode(window.innerWidth < consts/* DEVICE_SCREENS.sm */.XA.sm);
  }, []);
  var companyPages = pageList === null || pageList === void 0 ? void 0 : pageList.results.filter(function (page) {
    return page.site_section === SITE_SECTIONS.company;
  });
  var clientsPages = pageList === null || pageList === void 0 ? void 0 : pageList.results.filter(function (page) {
    return page.site_section === SITE_SECTIONS.clients;
  });
  var helpPages = pageList === null || pageList === void 0 ? void 0 : pageList.results.filter(function (page) {
    return page.site_section === SITE_SECTIONS.help;
  });
  helpPages === null || helpPages === void 0 ? void 0 : helpPages.push({
    external_link: '',
    open_in_new_window: false,
    redirect: false,
    remote_id: '',
    show_in_footer: false,
    show_in_rules: false,
    site_section: '',
    status: page/* PAGE_STATUS.active */.t.active,
    id: -1,
    slug: "".concat(currentCity.url, "/sitemap/"),
    title: 'Карта сайта',
    unique_content: null
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
    className: className,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      padding: '40px 0',
      backgroundColor: theme.colors.bgFooter,
      color: theme.colors.white,
      fontWeight: 500
    },  true ? "" : 0,  true ? "" : 0),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* Container */.W, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css2 = {
        paddingLeft: '8px',
        paddingRight: '8px'
      }, (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MIN_STRING.xxl */.zg.xxl, {
        maxWidth: '1280px !important'
      }), (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        display: 'flex',
        justifyContent: 'center'
      }), _css2),  true ? "" : 0,  true ? "" : 0),
      className: "container",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        // row footer__content
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css3 = {
          display: 'flex',
          marginRight: '-8px',
          marginLeft: '-8px',
          justifyContent: 'space-between',
          flexWrap: 'nowrap'
        }, (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
          display: 'grid',
          fontSize: 14,
          marginRight: '-10.5px',
          marginLeft: '-10.5px'
        }), (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          fontSize: 12.6,
          maxWidth: '100%'
        }), (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }), _css3),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // footer__logo
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css4 = {
            fontFamily: 'Golos',
            paddingRight: theme.constants.padding,
            paddingLeft: '30px',
            display: 'flex',
            flex: '1 0 0',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexGrow: 1,
            flexBasis: 0,
            order: 0
          }, (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            alignItems: 'center',
            justifyContent: 'center',
            order: 7,
            gridColumnStart: 1,
            gridColumnEnd: 3
          }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            alignItems: 'center',
            justifyContent: 'center'
          }), _css4),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            // bank_info
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css5 = {
              width: '100%',
              marginTop: 18
            }, (0,defineProperty/* default */.Z)(_css5, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
              marginTop: 8
            }), (0,defineProperty/* default */.Z)(_css5, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              width: '50%'
            }), _css5),  true ? "" : 0,  true ? "" : 0),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
              // bank_info__logos
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
                display: 'flex',
                gap: 12,
                listStyle: 'none',
                justifyContent: 'flex-start',
                padding: 0,
                margin: 0,
                marginBottom: '20px',
                li: {
                  overflow: 'hidden',
                  borderRadius: '3px',
                  height: '24px',
                  backgroundColor: theme.colors.white,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%'
              }),  true ? "" : 0,  true ? "" : 0),
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                  src: mastercard.src,
                  loading: "lazy",
                  title: "mastercard",
                  alt: "mastercard"
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                  src: mir.src,
                  css: _ref2,
                  loading: "lazy",
                  title: "mir",
                  alt: "mir"
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                css: _ref3,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                  width: "38px",
                  height: "17.2px",
                  src: visa.src,
                  loading: "lazy",
                  title: "visa",
                  alt: "visa"
                })
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
              // bank_info__features
              css: _ref4,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lock, {
                  css: _ref5,
                  loading: "lazy",
                  title: "lock icon",
                  alt: "lock icon"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                  children: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043A\u0430\u0440\u0442\u043E\u0439 \u043B\u044E\u0431\u043E\u0433\u043E \u0431\u0430\u043D\u043A\u0430. \u0417\u0430\u0449\u0438\u0442\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445."
                })]
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            // logo logo_footer
            css: _ref6,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(logo_footer, {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                width: '120px',
                height: '20px',
                fill: theme.colors.white
              },  true ? "" : 0,  true ? "" : 0)
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(logo_sk_uchastnik, {
              css: _ref7
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: _ref8,
            children: ["\xA9 2015-", currentYear, " Gorbilet.com"]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          // footer__divider footer__divider_vertical
          css: _ref9
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            height: '2px',
            display: 'none',
            order: 1
          }, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            display: 'block',
            width: '60%',
            margin: '40px auto',
            gridColumnStart: 1,
            gridColumnEnd: 3,
            order: 6
          }),  true ? "" : 0,  true ? "" : 0) // footer__divider footer__divider_horizontal

        }), !!companyPages.length && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // footer__company
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css8 = {
            fontFamily: 'Golos',
            margin: '0 auto',
            paddingRight: theme.constants.padding,
            paddingLeft: theme.constants.padding,
            flex: '1 0 0',
            order: 2
          }, (0,defineProperty/* default */.Z)(_css8, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            width: '100%',
            gridColumnStart: 1,
            gridColumnEnd: 2
          }), (0,defineProperty/* default */.Z)(_css8, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 30
          }), _css8),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
            children: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterList, {
            children: companyPages.map(function (page) {
              return page.external_link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  target: "_blank",
                  rel: "noreferrer",
                  href: page.external_link,
                  children: page.title
                }, "CompanyPageLink__".concat(page.id))
              }, "CompanyPageLi__".concat(page.id)) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
                  href: page.slug === 'vidzhety' || page.slug === 'person-catalog' ? ['', page.slug, ''].join('/') : ['', currentCity.url, page.slug, ''].join('/'),
                  children: page.title
                }, "CompanyPageLink__".concat(page.id))
              }, "CompanyPageLi__".concat(page.id));
            })
          })]
        }), !!helpPages.length && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // footer_help
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css9 = {
            fontFamily: 'Golos',
            margin: '0 auto',
            paddingRight: theme.constants.padding,
            paddingLeft: theme.constants.padding,
            flex: '1 0 0',
            order: 3
          }, (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            width: '100%',
            gridColumnStart: 2,
            gridColumnEnd: 3
          }), (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 30
          }), _css9),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
            children: "\u041F\u043E\u043C\u043E\u0449\u044C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterList, {
            children: helpPages.map(function (page) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
                  href: page.slug === 'faq' || page.id === -1 ? ['', page.slug, ''].join('/') : ['', 'pages', page.slug, ''].join('/'),
                  children: page.title
                }, "HelpPageLink__".concat(page.id))
              }, "HelpPageLi__".concat(page.id));
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: !!(socials !== null && socials !== void 0 && socials.results.length) && !isMobileMode && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              // social-question
              css: _ref10,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  // social-question__head
                  css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_objectSpread(_objectSpread({
                    cursor: 'pointer',
                    display: 'flex',
                    color: theme.colors.white,
                    marginBottom: '8px'
                  }, theme.mixins.fonts.fontBody), {}, {
                    svg: {
                      stroke: theme.colors.white
                    }
                  }),  true ? "" : 0,  true ? "" : 0),
                  children: "\u0417\u0430\u0434\u0430\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  // social-question__body
                  css: _ref11,
                  children: socials.results.map(function (social) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
                      rel: "noopener noreferrer",
                      target: "_blank",
                      href: social.url,
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
                        iconId: social.type
                      })
                    }, social.id);
                  })
                })]
              })
            })
          })]
        }), !!clientsPages.length && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // footer_clients
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            fontFamily: 'Golos',
            margin: '0 auto',
            paddingRight: theme.constants.padding,
            paddingLeft: theme.constants.padding,
            flex: '1 0 0',
            order: 4
          }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 30
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
            children: "\u041A\u043B\u0438\u0435\u043D\u0442\u0430\u043C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterList, {
            children: clientsPages.map(function (page) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
                  href: ['', 'pages', page.slug, ''].join('/'),
                  children: page.title
                }, "ClientsPageLink__".concat(page.id))
              }, "ClientsPageLi__".concat(page.id));
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          itemScope: true,
          itemType: "https://schema.org/Organization" // footer_contacts
          ,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css11 = {
            fontFamily: 'Golos',
            margin: '0 auto',
            paddingRight: theme.constants.padding,
            paddingLeft: theme.constants.padding,
            flex: '1 0 0',
            order: 5
          }, (0,defineProperty/* default */.Z)(_css11, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            width: '100%'
          }), (0,defineProperty/* default */.Z)(_css11, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            order: 4
          }), _css11),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "url",
            content: "https://".concat("gorbilet.com")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "logo",
            content: "https://".concat("gorbilet.com", "/apple-touch-icon-114x114.png/")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "sameAs",
            content: "https://vk.me/gorbilet"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "sameAs",
            content: "https://t.me/Gorbilet_otdel_zaboty_bot"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
            children: " \u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterList, {
            children: [contactList === null || contactList === void 0 ? void 0 : contactList.results.map(function (contact) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                children: [contact.type === CONCACT_TYPES.email && // eslint-disable-next-line jsx-a11y/control-has-associated-label
                (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: "mailto:".concat(contact.information),
                  itemProp: "email",
                  dangerouslySetInnerHTML: {
                    __html: contact.information
                  }
                }), contact.type === CONCACT_TYPES.telephone && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                  itemScope: true,
                  itemType: "https://schema.org/ContactPoint",
                  itemProp: "contactPoint",
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: "tel:".concat(contact.information),
                    dangerouslySetInnerHTML: {
                      __html: contact.information
                    }
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    itemProp: "telephone",
                    content: contact.information
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    itemProp: "contactType",
                    content: "customer service"
                  })]
                }), contact.type === CONCACT_TYPES.openingHours && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                  itemScope: true,
                  itemType: "http://schema.org/EntertainmentBusiness",
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: _ref12,
                    itemProp: "name",
                    children: "\u041E\u041E\u041E \"\u0413\u043E\u0440\u0431\u0438\u043B\u0435\u0442\""
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: _ref13,
                    itemProp: "address",
                    children: "\u043D\u0430\u0431. \u043A\u0430\u043D\u0430\u043B\u0430 \u0413\u0440\u0438\u0431\u043E\u0435\u0434\u043E\u0432\u0430, 5"
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: _ref14,
                    itemProp: "telephone",
                    children: "+7 (812) 603 46 33"
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("time", {
                    dateTime: "Mo-Su 10:00-22:00",
                    itemProp: "openingHours",
                    dangerouslySetInnerHTML: {
                      __html: contact.information
                    }
                  })]
                }), contact.type === CONCACT_TYPES.name && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  itemProp: "name",
                  dangerouslySetInnerHTML: {
                    __html: contact.information
                  }
                }), contact.type === CONCACT_TYPES.address && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  itemProp: "address",
                  itemScope: true,
                  itemType: "http://schema.org/PostalAddress",
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    dangerouslySetInnerHTML: {
                      __html: contact.information
                    }
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    itemProp: "name",
                    content: contact.information
                  })]
                })]
              }, "ClientsPageLi__".concat(contact.id));
            }), !!(socials !== null && socials !== void 0 && socials.results.length) && isMobileMode && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              // social-question
              css: _ref15,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  // social-question__head
                  css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_objectSpread(_objectSpread({
                    marginTop: 11,
                    cursor: 'pointer',
                    display: 'flex',
                    color: theme.colors.white,
                    marginBottom: '8px'
                  }, theme.mixins.fonts.fontBody), {}, {
                    fontFamily: 'Montserrat',
                    fontSize: 18,
                    lineHeight: '22px',
                    fontWeight: 700,
                    svg: {
                      stroke: theme.colors.white
                    }
                  }),  true ? "" : 0,  true ? "" : 0),
                  children: "\u0417\u0430\u0434\u0430\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  // social-question__body
                  css: _ref16,
                  children: socials.results.map(function (social) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                      href: social.url,
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
                        iconId: social.type
                      })
                    }, "SocialAnchor__".concat(social.id));
                  })
                })]
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            // footer__social
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              marginTop: '12px'
            }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              display: 'none',
              order: 0
            }),  true ? "" : 0,  true ? "" : 0),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
              css: _ref17,
              children: "\u041C\u044B \u0432 \u0441\u043E\u0446\u0441\u0435\u0442\u044F\u0445"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              // social-icons
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
                display: 'flex',
                justifyContent: 'flex-start'
              }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
                justifyContent: 'center'
              }),  true ? "" : 0,  true ? "" : 0),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                // body
                css: _ref18,
                children: socialsLinks.results.map(function (social) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: social.url,
                    "aria-label": social.title,
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
                      iconId: social.type
                    })
                  }, social.id);
                })
              })
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css14 = {
            fontFamily: 'Golos',
            margin: '0 auto',
            paddingRight: theme.constants.padding,
            paddingLeft: theme.constants.padding,
            flex: '1 0 0',
            order: 5
          }, (0,defineProperty/* default */.Z)(_css14, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            width: '100%'
          }), (0,defineProperty/* default */.Z)(_css14, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            order: 0,
            marginBottom: 30
          }), _css14),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: [apiUrl/* BLOG_DOMAIN */.SC, 'blog', ''].join('/'),
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442 \u0413\u043E\u0440\u0431\u0438\u043B\u0435\u0442 \u0431\u043B\u043E\u0433",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(logo_blog/* default */.Z, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            children: "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043E \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u043D\u043E\u0439 \u0436\u0438\u0437\u043D\u0438 \u0433\u043E\u0440\u043E\u0434\u0430"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // footer__social
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            marginTop: '12px',
            display: 'none'
          }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            order: 0,
            marginBottom: 30
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterTitle, {
            css: _ref19,
            children: "\u041C\u044B \u0432 \u0441\u043E\u0446\u0441\u0435\u0442\u044F\u0445"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            // social-icons
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              display: 'flex',
              justifyContent: 'flex-start'
            }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              justifyContent: 'center'
            }),  true ? "" : 0,  true ? "" : 0),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              // body
              css: _ref20,
              children: socialsLinks.results.map(function (social) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: social.url,
                  "aria-label": social.title,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
                    iconId: social.type
                  })
                }, "SocialLinkIcon__".concat(social.id));
              })
            })
          })]
        })]
      })
    })
  });
}

/***/ }),

/***/ 3393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PAGE_STATUS; }
/* harmony export */ });
var PAGE_STATUS = {
  active: 'active',
  inactive: 'inactive'
};

/***/ })

}]);